module.exports = __webpack_public_path__ + "static/Menu_Showcase-6eb11106bf37130a372b8e404b158669.png";